<template>
	<div class="all_app p_background clearfix">
		<h3 class="all_title">所有应用</h3>
		<section class="all_container container_box">
			<div class="operation_box clearfix">
				<div class="pull-right">
					<section class="search_box border_color">
						<input type="text" class="search_control" placeholder="输入应用名称" v-model.trim="appName" @keyup.enter="getSystemConfigList('1')"/>
						<i class="glyphicon icon_search" @click="getSystemConfigList('1')"></i>
					</section>
				</div>
			</div>
			<!--all state start-->
			<!--table start-->
			<div class="table_box clearfix">
				<table class="table table-hover text-center">
					<thead>
						<tr>
							<th>基本信息</th>
							<th>版本编号</th>
							<th>状态</th>
							<th>上线时间</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in page.content">
							<td class="text-left" style="cursor:pointer;" @click="lookAppCloudDetail(item.id,item.inspectStatus,item.publishStatus,item.saleVersionId,item.versionCount)">
								<div class="inline-block apply_thumbnail">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<span>{{item.appName}}</span>
							</td>
							<td>{{item.versionNo}}</td>
							<td v-if="item.appStatus == '3'" class="color_24bb19">禁止销售</td>
							<td v-else-if="item.inspectStatus == '9'" class="color_ff1212">准备提交</td>
							<td v-else-if="item.inspectStatus == '0'" class="color_2993ff">等待审核</td>
							<td v-else-if="item.inspectStatus == '3'" class="color_2993ff">正在审核</td>
							<td v-else-if="item.inspectStatus == '2'" class="color_2993ff">审核被拒</td>
							<td v-else-if="item.publishStatus=='0'  && item.inspectStatus == '1'" class="color_24bb19">等待上架</td>
							<td v-else-if="item.inspectStatus == '1' && item.appStatus== '1' && item.publishStatus == 1 " class="color_24bb19">可供销售</td>
							<td v-else-if="item.appStatus == '2'" class="color_24bb19">暂停销售</td>
							<td>{{item.publishTime?item.publishTime:''|time}}</td>
							<td class="text-right">
								<i v-if="item.inspectStatus == '0'" class="glyphicon icon_recall" @click="recall(item.saleVersionId,'9')" data-toggle="tooltip" data-placement="bottom" title="撤回"></i>
								<i v-if="item.versionCount<=1 && (item.appStatus== '1' || item.appStatus=='2') && item.inspectStatus == '1' && item.deployType != '109003'" class="glyphicon icon_stick" data-toggle="tooltip" @click='updateAppCloud(item.id,item.appversionid,item.versionCount)' data-placement="bottom" title="更新版本"></i>
								<i v-if="item.appStatus== '1' && item.publishStatus!='0' && item.inspectStatus == '1'" @click='showConfirm1(item.id)' class="glyphicon icon_pause" data-toggle="tooltip" data-placement="bottom" title="暂停销售"></i>
								<i v-if="item.saleVersionId==item.appversionid && item.inspectStatus!='3' && item.appStatus != '3'" @click='editAppCloud(item.id,item.saleVersionId,item.versionCount,item.inspectStatus)' class="glyphicon icon_edit" data-toggle="tooltip" data-placement="bottom" title="编辑"></i>
								<i v-else-if="item.saleVersionId!=item.appversionid && item.inspectStatus!='3'" @click='editAppCloud(item.id,item.saleVersionId,item.versionCount,item.inspectStatus)' class="glyphicon icon_edit" data-toggle="tooltip" data-placement="bottom" title="编辑"></i>
								<i v-if="((item.appStatus!= '1' || item.publishStatus=='0'  || item.appStatus=='2') && item.appStatus!= '3') && item.inspectStatus == '1'" @click='deployAppCloud(item.id,item.saleVersionId)' class="glyphicon icon_upline" data-toggle="tooltip" data-placement="bottom" title="上线销售"></i>
								<i v-if="item.appStatus== '3' && item.inspectStatus != '0' && item.inspectStatus != '0' && item.inspectStatus != '3'" class="glyphicon icon_relieve" data-toggle="tooltip" data-placement="bottom" @click="applyApp()" title="申请解禁"></i>
								<i v-if="item.versionCount<=1 && item.inspectStatus!= '3'" class="glyphicon icon_del" @click='showConfirm(item.id,item.saleVersionId)' data-toggle="tooltip" data-placement="bottom" title="删除"></i>
								<i v-else-if="item.versionCount>1 && item.saleVersionStatus!= '3'" class="glyphicon icon_del" @click='showConfirm(item.id,item.saleVersionId)' data-toggle="tooltip" data-placement="bottom" title="删除"></i>
							</td>
						</tr>
						<tr v-if="page.totalPages <=0 ">
							<td colspan="5">暂无数据</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--table end-->
			<input type="hidden" v-model="publicStatus" />
			<!--分页 start-->
			<div class="text-center" v-bind:class="page.totalPages > 0 ? 'show' : 'hidden'">
				<div class="row-fluid">
					<el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
				</div>
			</div>
			<!--分页 end-->

			<!--模态弹出-->
			<v-tip :trueFlag="trueFlag" :falseFlag="falseFlag" :tipMsg="tipMsg"></v-tip>

			<!--confirm-->
			<v-confirm v-if="confirmFlag" :bigMsg="bigMsg" @confirmOff="confirmFlag = !confirmFlag" @confirmTrue="deleteAppVersionCloud"></v-confirm>
		</section>

		<v-confirm v-if="confirmFlag1" :bigMsg="bigMsg1" @confirmOff="confirmFlag1 = !confirmFlag1" @confirmTrue="stopAppCloud"></v-confirm>
		</section>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	import router from './../router/index';

	export default {
		name: 'all_app',
		data() {
			return {
				currentPage:1,
	      		pageSize:10,
				trueFlag: false,
				falseFlag: false,
				tipMsg: '',
				bigMsg: '删除此应用版本吗?',
				bigMsg1: '暂停此应用吗?',
				confirmFlag: false,
				confirmFlag1: false,
				page: '',
				appCount: '',
				publicStatus: '',
				appName: '',
				tempId: '',//应用ID
        appVersionId:'',//应用版本ID
				flag: false
			}
		},
		// 页面初始化
		created: function() {
			var _this = this;
			this.$nextTick(function() {
				this.getSystemConfigList();
			});
		},
		methods: {
			getSystemConfigList(obj) {
				if(obj == '1'){
					this.currentPage = 1;
				}
				var temp = this;
				this.$http.post('/zklccloud/findTCloudAppList',{"appName": this.appName,"page": this.currentPage - 1,"size":this.pageSize}, {
					emulateJSON: true
				}).then(function(m) {
					temp.page = m.data.content.page
				})
			},
			handleSizeChange(val) {
	        	this.pageSize = val;
	        	this.currentPage = 1;
	            var temp = this;
	            this.$http.post('/zklccloud/findTCloudAppList',{"appName":this.appName,"page": this.currentPage - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
			      	temp.page = m.data.content.page
			    })
	        },
	        handleCurrentChange(val) {
	        	this.currentPage = val;
	            var temp = this;
	            this.$http.post('/zklccloud/findTCloudAppList',{"appName":this.appName,"page": val - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
			      	temp.page = m.data.content.page
			    })
	       },
			showConfirm(id,appVersionId) {
				this.tempId = id;
				this.appVersionId=appVersionId;
				this.confirmFlag = true;
			},
			deleteAppCloud() {
				var temp = this;
				this.$http.post('/zklccloud/deleteTCloudAppById', {
					"appid": this.tempId
				}, {
					emulateJSON: true
				}).then(function(m) {
					this.getSystemConfigList();
					this.confirmFlag = false;
				})
			},
      deleteAppVersionCloud() {
        var temp = this;
        this.$http.post('/zklccloud/deleteTCloudAppVersionByAppVersionId', {
          "appVersionId": this.appVersionId
        }, {
          emulateJSON: true
        }).then(function(m) {
          this.getSystemConfigList();
          this.confirmFlag = false;
        })
      },
			deployAppCloud(id, vId) {
				var temp = this;
				this.$http.post('/zklccloud/updateTCloudAppStatus', {
					"id": id,
					"appStatus": 1,
					"appversionid": vId
				}, {
					emulateJSON: true
				}).then(function(m) {
					this.getSystemConfigList();
				})
			},
			showConfirm1(id) {
				this.tempId = id;
				this.confirmFlag1 = true;
			},
			stopAppCloud() {
				var temp = this;
				this.$http.post('/zklccloud/updateTCloudAppStatus', {
					"id": this.tempId,
					"appStatus": 2
				}, {
					emulateJSON: true
				}).then(function(m) {
					this.getSystemConfigList();
					this.confirmFlag1 = false;
				})
			},
			recall(vId, status) {
				var temp = this;
				this.$http.post('/zklccloud/updateTCloudAppVersionStatus', {
					"versionId": vId,
					"status": status
				}, {
					emulateJSON: true
				}).then(function(m) {
					this.getSystemConfigList();
				})
			},
			lookAppCloudDetail(id, status, publicStatus, vId, len) {
				this.$router.push({
					name: 'app_detail',
					params: {
						appid: id,
						vStatus: status,
						vpublicStatus: publicStatus,
						vId: vId,
						appCount: len
					}
				});
			},
			editAppCloud(id, appversionid, slen, inspetctstatus) {
				if(slen && slen == 2) {
					this.flag = true;
				}
				this.$router.push({
					//name: 'add_app',
					name: 'publish_apply',
					params: {
						appid: id,
						appVersionId: appversionid,
						versioncontent: this.flag,
						inspertStatus: inspetctstatus
					}
				});
			},
			updateAppCloud(id, appversionid, slen) {
				if(slen && slen == 2) {
					this.flag = true;
				}
				this.$router.push({
					name: 'edit_app',
					params: {
						appid: id,
						appVersionId: appversionid,
						versioncontent: this.flag
					}
				});
			},
			applyApp() {
				MessageBox('请联系客服！', '提示', 'error', {
					confirmButtonText: '确定',
				}).then(() => {});

				if($(".el-message-box__btns")) {
					$(".el-message-box__btns").attr("id", "btnSub");
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.operation_box {
		margin-bottom: 15px;
	}

	.operation_box>section {
		border-right: 1px solid #eee;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		height: 30px;
		line-height: 30px;
		padding: 0 13px;
		cursor: pointer;
		color: #666;
	}

	.operation_box>section:first-child {
		border-left: 1px solid #eee!important;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0
	}
</style>



// WEBPACK FOOTER //
// all_app.vue?6a7827ba